import React, { FC } from 'react';
import { AdminCompaniesView } from '../../components';

export const AdminCompaniesPage: FC = () => {
  return <AdminCompaniesView />;
};
